// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"084a6674","194":"f3c66f57","216":"5d46bf8c","274":"5f8402f5","434":"6019c2f4","555":"0985b1d7","677":"8a2afe22","773":"6a3c68c3","861":"856f26be","881":"5c8aea80","925":"4f2fe926","986":"96c3dda0"}[chunkId] + ".chunk.js";
};